import { useTheme } from "@mui/material";
import LibUtils from "lib/LibUtils";
import { MuiOtpInput, MuiOtpInputProps } from "mui-one-time-password-input";
import React, { useImperativeHandle, useRef } from "react";

export type MprcTwoFactorAppPinCodeHandle = {
    focusFirstBox: () => void,
};
export interface IMprcPinCodeFieldProps extends Omit<MuiOtpInputProps, "TextFieldsProps"> {
    isNumeric: boolean;
}

const MprcPinCodeFieldComponent: React.ForwardRefRenderFunction<MprcTwoFactorAppPinCodeHandle, IMprcPinCodeFieldProps> = (props, forwardRef) => {

    const theme = useTheme();
    const firstBoxRef = useRef<HTMLInputElement>(undefined);

    /////////////////////////////////////////////////////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////////////////////////////////////////////////////

    useImperativeHandle(forwardRef, () => ({
        focusFirstBox: () => {
            setTimeout(() => firstBoxRef.current?.focus(), 100);
        }
    }));

    /////////////////////////////////////////////////////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////////////////////////////////////////////////////

    return <MuiOtpInput
        {...props}
        validateChar={props.isNumeric ? LibUtils.matchIsNumeric : props.validateChar}
        TextFieldsProps={
            (index) => ({
                inputRef: index == 0 ? firstBoxRef : null,
                variant: "outlined",
                sx: {
                    backgroundColor: "#EEEEEE",
                    '& .MuiOutlinedInput-root': {
                        '& fieldset': {
                            borderColor: theme.palette.warning.main,
                        },
                        '&:hover fieldset': {
                            borderColor: theme.palette.warning.dark,
                            borderWidth: "2px"
                        },
                        '&.Mui-focused fieldset': {
                            borderColor: theme.palette.warning.main,
                        },
                    },
                },
            })
        }
    />;
};

export const MprcPinCodeField = React.forwardRef(MprcPinCodeFieldComponent);